<div class="card" rte="h2">
    <h1 rte="h3">{{page.heading}}</h1>
    <div *ngIf="page && page.contents" [innerHtml]="page.contents | keepHtml" rte="h4"></div>
</div>